import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { TabContent, TabPane } from 'reactstrap';
import { ACTIVE_TAB } from '../utils/constants';

const DynamicNavigationTabsHidden = ({ children, activeTab }) => {
  return (
    <div className="tabs tabs--justify tabs--bordered-bottom overflow-inherit">
      <div className="tabs__wrap">
        <TabContent activeTab={activeTab}>
          <TabPane tabId={activeTab}>
            {children[Number(activeTab - ACTIVE_TAB.ONE)]}
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
};

DynamicNavigationTabsHidden.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  activeTab: PropTypes.string.isRequired,
};

export default withTranslation('common')(DynamicNavigationTabsHidden);
